import styled from 'styled-components';
import { Drawer, Button, Icon, RouteLink, ControlPanelItem } from '@sumtotal/react-foundation';

export const SideBar = styled.div`
  background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
`;

export const ExpandButton = styled(Button)`
  height: 3rem;
  border: 0;
  border-radius: 0.1875rem;
  padding: 0.75rem 0.375rem;
  margin: 0.5rem 0.25rem 0.063rem 0.25rem;
  box-shadow: none;
  font-weight: 500;
  text-transform: none;
  width: 5.125rem;
  justify-content: center;
  display: flex;
  background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
  color: ${(props) =>
    props.active
      ? props.theme.variables.topbarNavActiveStateTextColor
      : props.theme.variables.leftNavParentColor};
  &:hover {
    background-color: ${(p) => p.theme.variables.topbarNavHoverStateBackground};
    color: ${(p) => p.theme.variables.topbarNavHoverStateTextColor};
    border: 0;
  }
  &:active {
    background-color: ${(p) => p.theme.variables.topbarNavActiveStateBackground};
    color: ${(p) => p.theme.variables.topbarNavActiveStateTextColor};
  }
  &:focus {
    background-color: ${(p) =>
      p.active
        ? p.theme.variables.topbarNavActiveStateBackground
        : p.theme.variables.topbarNavHoverStateBackground};
    color: ${(p) => p.theme.variables.topbarNavHoverStateTextColor};
  }
  &:focus-visible {
    border: 0.125rem solid ${(p) => p.theme.variables.topbarNavTabOutlineColor};
    border-radius: 0.3rem;
  }
  &:disabled {
    color: ${(props) => props.theme.variables.leftNavParentColor};
    opacity: 0.5;
    border: none;
    pointer-events: none;
  }
`;

export const StyledIcon = styled(Icon)`
  display: flex;
  justify-content: center;
`;

export const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    width: ${(props) => (props.sliderOpen ? '17.5rem' : '5.625rem')};
    height: calc(100%);
    top: 3.25rem;
    z-index: 1203;
    border-right: none;
    background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
    transition: all 0.3s linear !important;
    box-shadow: rgba(0, 0, 0, 0.15) 0.122rem 0.122rem 0.162rem;
  }
`;

export const CollapseIcon = styled(Icon)`
  display: flex;
  justify-content: start;
  padding-left: 1.75rem;
`;

export const ScrollContainer = styled.div`
  overflow: ${(props) => (props.sliderOpen ? 'hidden' : 'auto')};
  width: ${(props) => (props.sliderOpen ? '5.625rem' : '17.5rem')};
  .ScrollbarsCustom-Content {
    padding: 0 0 0 0 !important;
    overflow: hidden;
  }
  .StyledCustomScroll {
    &[style] {
      &.ScrollbarsCustom-TrackY {
        height: calc(100% - 8rem) !important;
      }
    }
  }
  .ScrollbarsCustom-Scroller {
    height: calc(100% - 6.75rem) !important;
  }
  .ScrollbarsCustom-TrackY {
    height: calc(100% - 8rem) !important;
  }
`;

export const StyledRouteLink = styled(RouteLink)`
  position: fixed;
  display: flex;
  justify-content: center;
  bottom: 0rem;
  width: ${(props) => (props.panelExpanded ? '17.5rem' : '5.625rem')};
  background-color: inherit;
  margin-top: 0.75rem;
  text-transform: none;
  font-size: 0.75rem;
  line-height: 1rem;
  text-decoration: underline;
  font-weight: 400;
  padding: 0.0625rem 0.0625rem 0.75rem;
  color: ${(props) => props.theme.variables.leftNavParentColor};
  &:focus,
  &:hover,
  &:active {
    text-decoration: underline;
  }
`;
export const DisabledLink = styled(StyledRouteLink)`
  pointer-events: none;
  opacity: 0.5;
`;

export const StyledLinkContainer = styled.div`
  background-color: inherit;
  width: ${(props) => (props.panelExpanded ? '100%' : '5.625rem')};
  display: flex;
  justify-content: center;
`;

export const CollapsedButton = styled(ControlPanelItem)`
  width: ${(props) => (props.panelExpanded ? '17.5rem' : '5.625rem')};
  padding: 0 0.25rem 0rem 0.25rem;
  margin-bottom: 0.08rem;
  background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
  color: ${(props) =>
    props.active
      ? props.theme.variables.topbarNavActiveStateTextColor
      : props.theme.variables.leftNavParentColor};
  &:focus {
    background-color: ${(props) => props.theme.variables.topbarNavHoverStateBackground};
  }
`;
